<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import {useDisplay} from "vuetify";
import ConnectionRow from "@/components/ConnectionRow.vue";

@Options({

  computed: {
    smAndDown() {
      return useDisplay().smAndDown.value;
    }
  },
  components: {
    ConnectionRow,
    MainAppBar
  },
  data() {
    return {
      items: [
        {text: "Real-Time", icon: "mdi-clock"},
        {text: "Audience", icon: "mdi-account"},
        {text: "Conversions", icon: "mdi-flag"}
      ],
      drawer: false,
      workshopImg: require("@/assets/main.gif"),
      jacket: require("@/assets/jacket.png"),
      logo: require("@/assets/himzokucko.jpg"),
      towels: require("@/assets/towels.png"),
      sticky: require("@/assets/sticky.png"),
      bag: require("@/assets/bag.png"),
      baseImg: require("@/assets/base.png"),
      innerWidth: 1000,
      banners: [
        {
          big: require("@/assets/himzőkuckó banner1.jpg"),
          small: require("@/assets/banner telefon.jpg")
        },
        {
          big: require("@/assets/himzőkuckó banner2.jpg"),
          small: require("@/assets/banner telefon2.jpg")
        },
        {
          big: require("@/assets/himzőkuckó banner3.jpg"),
          small: require("@/assets/banner telefon3.jpg")
        },
        {
          big: require("@/assets/himzőkuckó banner4.jpg"),
          small: require("@/assets/himzőkuckó banner2.jpg")
        }
      ],
      overlay: true,
      icons: [
        "mdi-facebook",
//        'mdi-twitter',
        "mdi-linkedin"
//        'mdi-instagram',
      ]
    };
  },
  methods: {
    onAboutClick(): void {
      this.$router.push("company");
    },
    onConnectionClick(): void {
      this.$router.push("connection");
    }
  }
})
export default class OpenView extends Vue {
  get smAndDown(): boolean {
    return useDisplay().smAndDown.value;
  }
}
</script>

<template>
  <v-app >
    <main-app-bar elevation="5" app-bar-color="" app-bar-text-color="">
    </main-app-bar>
    <v-main class="mainDiv" v-bind:style="{ 'background-image': 'url(' + baseImg + ')'}">
      <div style="position: absolute; top: 65px; left: 0; right: 0; bottom: 10px; overflow-y: scroll">
        <section >
          <v-container class="mb-0 pb-0 px-0 pt-0" fluid>
            <v-carousel :height="smAndDown ? '20vh' : '80vh'" class="pb-0" show-arrows="hover" cycle
                        hide-delimiter-background hide-delimiters>
              <v-carousel-item v-for="(banner, i) in banners" :key="i">
                <img :src="smAndDown ? banner.big : banner.big" class="carousel-image">
              </v-carousel-item>
            </v-carousel>
          </v-container>
        </section>
        <section  class="mt-5 pb-0">

          <v-container class="pt-0 mb-0 pb-0" fluid>
            <v-row align="center" justify="center">
              <v-col lg="8" xs="12">

                <v-card style="background-color: #ffffffa0">
                    <h1 class="queensFont" style="text-align: center; font-size: 45px;">Prémium minőségű gépi hímzés</h1>
                    <h2 class="pb-6 queensFont" style="text-align: center; font-size: 35px">Egyedi megoldások cégeknek és
                      magánszemélyeknek</h2>

                  <v-card-text class="playFairFont">
                    <p class="pb-3" style="font-size: 25px">
                      A gépi hímzés az egyik legidőtállóbb és legelegánsabb módja a textíliák díszítésének. Kiváló választás,
                      ha
                      tartós és exkluzív megjelenést szeretnél biztosítani ruházati termékeidnek vagy promóciós ajándékaidnak.
                    </p>
                    <p class="pb-3" style="font-size: 25px">
                      A hímzett minták nem fakulnak, nem kopnak le, így hosszú távon is megőrzik esztétikai értéküket.
                    </p>
                    <p class="pb-3" style="font-size: 25px">
                      Modern gépi hímzési technológiánknak köszönhetően részletgazdag, precíz és egyedi mintákat készítünk
                      különböző textíliákra. Legyen szó céges logóról, feliratokról, emblémákról, egyedi grafikákról vagy
                      névre
                      szóló ajándékokról, szakértelmünkkel és korszerű berendezéseinkkel garantáljuk a magas minőségű
                      végeredményt.
                    </p>
                    <p style="font-size: 25px">
                      Szolgáltatásunkkal segítünk kiemelkedni a tömegből, legyen szó egységes vállalati arculatról, személyre
                      szabott ajándékokról vagy exkluzív textil termékekről.
                    </p>

                  </v-card-text>

                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </section>
        <section class="mt-2">

          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col lg="8" xs="12">
                <v-card
                    class="mx-auto"
                    style="background-color: #ffffffa0"
                >
                    <h1 class="queensFont" style="text-align: center; font-size: 45px">
                      Miért válassz minket
                    </h1>
                  <v-list class="playFairFont" style="background: #ffffff00" density="compact" lines="three">
                    <v-list-item
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="orange" icon="mdi-seal"></v-icon>
                      </template>
                      <p>
                        <b>Prémium minőség</b> – Modern hímzőgépeinkkel pontos és részletgazdag mintákat készítünk.
                      </p>
                    </v-list-item>
                    <v-list-item
                        color="primary"
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="purple" icon="mdi-arm-flex-outline"></v-icon>
                      </template>
                      <p>
                        <b>Tartós kivitelezés</b> – A hímzés ellenáll a kopásnak és mosásnak, így hosszú távon is megőrzi
                        szépségét.
                      </p>
                    </v-list-item>
                    <v-list-item
                        color="primary"
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="brown" icon="mdi-unicode"></v-icon>
                      </template>
                      <p>
                        <b>Egyedi igényekre szabva</b> – Legyen szó kis darabszámról vagy nagy tételű gyártásról,
                        rugalmasan alkalmazkodunk az elképzeléseidhez.
                      </p>
                    </v-list-item>
                    <v-list-item
                        color="primary"
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="blue" icon="mdi-tshirt-v"></v-icon>
                      </template>
                      <p>
                        <b>Széles anyagválaszték</b> – Pólók, pulóverek, sapkák, munkaruhák, törölközők és sok más
                        textiltermék hímzését vállaljuk.
                      </p>
                    </v-list-item>
                    <v-list-item
                        color="primary"
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="red" icon="mdi-finance"></v-icon>
                      </template>
                      <p>
                        <b>Kis és nagy darabszámban is elérhető</b> – Rugalmasan alkalmazkodunk az igényeidhez, legyen szó
                        egyedi darabokról vagy nagyobb megrendelésekről.
                      </p>
                    </v-list-item>
                    <v-list-item
                        color="primary"
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="indigo" icon="mdi-speedometer"></v-icon>
                      </template>

                      <p>
                        <b>Gyors és pontos kivitelezés</b> – Hatékony munkafolyamatainknak köszönhetően rövid határidővel
                        vállaljuk a hímzést.
                      </p>
                    </v-list-item>
                    <v-list-item
                        color="primary"
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="deep-orange" icon="mdi-help-circle"></v-icon>
                      </template>

                      <p>
                        <b>Segítünk a tervezésben</b> – Ha nincs kész mintád, grafikai támogatást is biztosítunk az
                        elképzelésed megvalósításához.
                      </p>
                    </v-list-item>
                    <v-list-item
                        color="primary"
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="green-darken-4" icon="mdi-cash"></v-icon>
                      </template>

                      <p>
                        <b>Versenyképes árak</b> – Kiváló minőséget kínálunk megfizethető áron, hogy a lehető legjobb
                        ár-érték arányt kapd.
                      </p>
                    </v-list-item>
                    <v-list-item
                        color="primary"
                        style="font-size: 25px"
                    >
                      <template v-slot:prepend>
                        <v-icon color="teal-darken-4" icon="mdi-account-group"></v-icon>
                      </template>

                      <p>
                        <b> Céges és magán megrendeléseket is vállalunk</b> – Legyen szó egyedi meglepetésről vagy céges
                        ruházatról, minden ügyfelünk fontos számunkra.
                      </p>
                    </v-list-item>
                  </v-list>
                </v-card>

              </v-col>
            </v-row>
          </v-container>
        </section>
        <section >
          <v-container fluid>
            <h1 style="text-align: center; font-size: 45px" class="mb-5 queensFont">
              Gyakran feltett kérdések
            </h1>
            <v-row class="playFairFont" align="center" justify="center">
              <v-col lg="8" xs="12">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Mi az a gépi hímzés?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      A gépi hímzés egy automatizált folyamat, amely során számítógép-vezérelt hímzőgép szálakkal mintát
                      varr textilre. Ez lehet logó, szöveg, grafika vagy bármilyen egyedi motívum.
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Mire lehet gépi hímzést használni?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      Leggyakrabban: <br>
                      Céges pólók, ingek, kabátok logózására <br>
                      Egyenruhák, munkaruhák díszítésére <br>
                      Törölközők, köntösök, sapkák, táskák, zászlók személyre szabására <br>
                      Egyedi ajándéktárgyak készítésére
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Milyen anyagokra lehet hímezni?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      Szinte minden textilre: pamut, poliészter, frottír, vászon, softshell, filc stb. Vastagabb anyagokra
                      (pl. polár, dzseki) is lehet hímzést készíteni, csak a minta kialakításánál figyelembe kell venni az
                      anyag tulajdonságait.
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Hogyan kell a mintát elküldeni?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      A legjobb, ha vektoros formátumban (pl. .ai, .eps, .svg, .cdr) küldöd el a logót vagy mintát. Ha ez
                      nem elérhető, akkor jó minőségű .jpg vagy .png is megfelel, de ilyenkor plusz digitalizálásra lehet
                      szükség.
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Mi az a digitalizálás?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      A digitalizálás az a folyamat, amikor a grafikai mintát átalakítjuk hímzőgéppel olvasható formátumra
                      (pl. .dst, .emb, .pes). Ez nem ugyanaz, mint egy képfájl megnyitása: a minta minden öltését, irányát
                      és típusát meg kell határozni.
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Mennyibe kerül a gépi hímzés?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      Az ár több tényezőtől függ: <br>
                      A minta mérete és bonyolultsága <br>
                      Hány darabot kell hímezni <br>
                      Milyen anyagra kerül a hímzés <br>
                      Egyszeri digitalizálási díj (ha még nincs kész minta)
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Van minimális rendelési mennyiség?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      Általában nincs, de 1-2 darab esetén magasabb az egységár, mivel a gép beállítása és a digitalizálás
                      ugyanannyi időt igényel, mint nagyobb tételnél.
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Mennyi idő alatt készül el a hímzés?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      Átlagosan 3-10 munkanap, de sürgős megrendeléseknél előzetes egyeztetés után gyorsabb határidő is
                      lehetséges.
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Mosható-e a gépi hímzés?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      Igen, a hímzés nagyon tartós. Jellemzően 60 °C-ig mosható, nem kopik le, nem fakul el, mint a
                      nyomott minták. Az anyag kezelési útmutatóját azért érdemes követni.
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                  <v-expansion-panel class="mt-5">
                    <v-expansion-panel-title style="font-size: 25px" collapse-icon="mdi-minus" expand-icon="mdi-plus">
                      Lehet-e színes mintát is hímezni?
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      Igen, a gépi hímzés többféle színű cérnával dolgozik. Egyszerre általában 10-15 szín használható, de
                      a legtöbb logóhoz ez bőven elegendő.
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </section>
        <section >
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col lg="8" xs="12">
                <v-card style="background-color: #ffffffa0">
                    <h1 style="text-align: center; font-size: 45px" class="queensFont mb-5">
                      Lépjen kapcsolatba velünk
                    </h1>
                  <connection-row></connection-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </section>
        <v-footer class="bg-indigo-lighten-1 d-flex flex-column playFairFont">
          <div class=" d-flex w-30 align-center px-4">
            <strong>Kövess minket</strong>

            <v-spacer></v-spacer>

            <v-btn
                v-for="icon in icons"
                :key="icon"
                :icon="icon"
                class="mx-4"
                size="small"
                variant="plain"
            ></v-btn>
          </div>

          <div class="px-4 py-2  text-center w-100">
            {{ new Date().getFullYear() }} — <strong>Kreatív hímzőkuckó</strong>
          </div>
        </v-footer>

      </div>
    </v-main>

  </v-app>
</template>


<style scoped>



.mainDiv {
  background-repeat: no-repeat;
  /*background-attachment: fixed;*/
  background-size: cover;
  background-position: 10% 10%;
}

.carousel-bg {
  width: 100%;
  height: 100%;
  background-size: contain; /* vagy cover */
  background-repeat: no-repeat;
  background-position: center;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
  object-position: center;
}
</style>